module.exports = __webpack_public_path__ + "img/chat-dots.de877801.svg";